<div id="subscription-alert">
  <p class="text" [outerHTML]="'project.subscription.info.demo' | translate"></p>
  <footer>
    <a class="submit-button" [href]="subscriptionsUrl" target="_blank">{{'project.subscription.label' | translate}}</a>
  </footer>
</div>
